import { render } from "./HomePart1.vue?vue&type=template&id=3b755a64&scoped=true&ts=true"
import script from "./HomePart1.vue?vue&type=script&lang=ts"
export * from "./HomePart1.vue?vue&type=script&lang=ts"

import "./HomePart1.vue?vue&type=style&index=0&id=3b755a64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b755a64"]])

export default __exports__